module.exports = __webpack_public_path__ + "img/ys-nine-grid-select.4eb1b7f4.png";